(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceRelationController', InsuranceRelationController);

    InsuranceRelationController.$inject = ['InsuranceRelation', 'CoreService', 'GenericEntityDatatableService', '$q',
        '$uibModal', 'ConfirmationService'];

    function InsuranceRelationController (InsuranceRelation, CoreService, GenericEntityDatatableService, $q,
                                          $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation()

        vm.descriptor = {
            title: 'Insurance Relation',
            entityClassHumanized: 'Insurance Relation',
            entityStateName: 'insurance-relation',
            service: InsuranceRelation,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            newButtonTitle: 'New Insurance Relation',
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Relation',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-relation/update/insurance-relation-dialog.html',
                controller: 'InsuranceRelationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-relation/update/insurance-relation-dialog.html',
                controller: 'InsuranceRelationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceRelation', function (InsuranceRelation) {
                        return InsuranceRelation.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Insurance Relation').result.then(function () {
                    InsuranceRelation.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
